<template>
    <div class="quote flex flex-col  bg-view-sand/30 p-16 justify-start items-center text-dark-blue relative z-10 rounded-sm">
        <div class="max-w-6xl flex flex-col sm:flex-row gap-16">
            <div
                v-if="content?.image"
                class="rounded-full w-52 h-52 shrink-0 self-center bg-center bg-cover"
                :style="`background-image: url('/api/files/image/${content?.image}')`"
            ></div>
            <div class="flex flex-col gap-16 justify-center sm:justify-start text-center sm:text-left">
                <div class="quote-text self-start">{{ get_localized_value(content?.value) }}</div>
                <div class="flex flex-col gap-0 self-center sm:self-start text-sm sm:text-base">
                    <div class="view-h3">{{ get_localized_value(content?.author) }}</div>
                    <div class="view-body">{{ get_localized_value(content?.['who-is-it']) }}</div>
                </div>

            </div>

        </div>
    </div>
</template>

<script lang="ts" setup>
const { get_value: get_localized_value } = useLocalizedValue()

const {content} = defineProps({
    content: {
        type: Object
    },
    image: {
        required: false,
        type: String
    },
    properties: {
        type: Array as PropType<{translate: boolean, label: string}[]>
    }
})

</script>

<!--<style scoped lang="scss">-->
<!--</style>-->
